export default  {	
	data () {
		return { 
			filter: {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_list_mes: null,
				id_list_ano: null,
				id_datos_razon: null,
				prioridad: false,
				sinPrioridad: false,
				servicios: [],
				planilla: { "compare": "=", "value": null }
			}
		}
	},
	watch: {
		'filter.sinPrioridad': function (value) {
			if (value) {
				this.filter = {
					...this.filter,
					prioridad: false
				}
			}
		},
		'filter.prioridad': function (value) {
			if (value) {
				this.filter = {
					...this.filter,
					sinPrioridad: false
				}
			}
		}
	},
	async created () { 
		this.filter.id_list_mes= this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0]
		this.filter.id_list_ano= this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0]
		this.filter.id_datos_razon= this.gettersDatalist('datos_razon',1)[0]
	},
	destroyed()
	{
		this.updateCrud({state: 'dataGet/archivo_aportes/data',data:[]})
	}
}
